import { render, staticRenderFns } from "./MapDetailsInst.vue?vue&type=template&id=0f785672"
import script from "./MapDetailsInst.vue?vue&type=script&lang=js"
export * from "./MapDetailsInst.vue?vue&type=script&lang=js"
import style0 from "./MapDetailsInst.vue?vue&type=style&index=0&id=0f785672&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports